import React, { useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { pathApp } from "services/utiles";

const TabSwitch = ({
  colorD,
  backgroundC,
  backgroundA,
  pathLogin = "",
  pathSignUp = "",
  path,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const navigation = useNavigate();

  // console.log('path',path);

  useEffect(() => {
    if (path === `/gift-signup` || path === `/trial-signup`) {
      setActiveTab(0);
    } else {
      setActiveTab(1);
    }
  }, [path]);

  const handleTabClick = (tabIndex, path) => {
    setActiveTab(tabIndex);
    navigation(path);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "auto",
          maxWidth: "16%",
          zIndex: 999,
          position: "relative",
          "@media (max-width: 600px)": {
            minWidth: "48%",
          },
        }}
      >
        <Button
          onClick={() => handleTabClick(1, pathLogin || `/gift-login`)}
          sx={{
            color: colorD,
            background:
              path === `/gift-login` || path === `/trial-login`
                ? backgroundA
                : backgroundC,
            borderRadius: "6px 0px 0px 6px",
            width: "50%",
            padding: "3px",
            "&:hover": { background: backgroundC },
          }}
        >
          Log in
        </Button>
        <Button
          onClick={() => handleTabClick(0, pathSignUp || `/gift-signup`)}
          sx={{
            color: colorD,
            background:
              path === `/gift-signup` || path === `/trial-signup`
                ? backgroundA
                : backgroundC,
            borderRadius: "0 6px 6px 0px",
            padding: "3px",
            width: "50%",
            "&:hover": { background: backgroundA },
          }}
        >
          Sign up
        </Button>
      </Box>
    </Box>
  );
};

export default TabSwitch;
